import React, { ReactElement } from 'react';

export const ConditionalWrapper: React.FunctionComponent<{
  condition: boolean;
  wrapper: (children: ReactElement) => ReactElement;
  children: ReactElement | any;
}> = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);
